import axios from 'axios';
import { Statistic } from 'src/types/statistics/Statistics';
import {
  STATISTIC_API_BASE_URL,
  STATISTIC_API_KEY,
} from '../../utils/envConfig';

const statisticInstance = axios.create({
  baseURL: STATISTIC_API_BASE_URL,
  headers: { 'X-TRIHOW-API-KEY': STATISTIC_API_KEY },
});

/**
 * Class is used to upload statistics to the statistic service
 */
export class StatisticService {
  /**
   * Can be called globally to emit any payload
   * @param data any statistic payload you want to emit
   */
  public static async uploadStatistic(data: Statistic) {
    const restResponse = await statisticInstance
      .post('/uploadStatistic', data)
      .catch((err) => {
        // check if the error is due to validation, in this case make the error more clear
        if (err.response.data.code === 400) {
          console.error(
            `[STATISTICS-SERVICE]: Error while uploading statistic with error -> ${JSON.stringify(
              err.response.data.message,
            )}`,
          );
        } else {
          console.error(
            `[STATISTICS-SERVICE]: Error while uploading statistic with error -> ${err}`,
          );
        }
      });

    if (restResponse?.status === 201) {
      // eslint-disable-next-line no-console
      console.info('[STATISTICS-SERVICE]: Successfully uploaded statistic');
    } else {
      console.error(
        `[STATISTICS-SERVICE]: Failed to upload statistic; Error -> ${restResponse?.data}`,
      );
    }
  }
}
